import {
  BMComponentsType,
  BMPrimitives,
  useBMTheme,
} from "@traveloka/district-bloom";
import { useMemo } from "react";
import { StyleSheet, View } from "react-native";

import type { BMCorporateSelectionPopupVariant } from "../types";

type Props = { variant: BMCorporateSelectionPopupVariant };

export default function CorporateOptionCardSkeleton({ variant }: Props) {
  const { BMComponents } = useBMTheme();
  const styles = useMemo(() => createStyles(BMComponents), [BMComponents]);
  return (
    <View
      style={[styles.row, variant === "mobile" ? styles.mobile : styles.desktop]}
    />
  );
}

const createStyles = (BMComponents: BMComponentsType) =>
  StyleSheet.create({
    row: {
      backgroundColor: BMComponents.BMStyleSurfaceBgcolorDisabled,
      borderRadius: BMPrimitives.BMRadius.rounded,
    },
    desktop: { width: 552, height: 88 },
    mobile: { width: 303, height: 60 },
  });
